<template>
<div style="margin:0px auto;width: 1060px;background: #fff;height: 100%;" >
    <el-table
                :data="tabList"
                border
                :row-class-name="tableRowClassName"
                 @sort-change='tableSortChange'
                style="width: 100%;margin-top: 10px;" v-loading="loading">


                 <el-table-column
                  :label="$t('nav.아이디')" align="center"  prop="username" width="100">
                </el-table-column>
               
                <el-table-column
                  :label="$t('nav.게임사')" align="center"  prop="provider_name" width="150">
                </el-table-column>
                 
                  <el-table-column
                  :label="$t('tableText.게임명')"
                   align="center" prop="game_title">
                </el-table-column>
                

                
                

                 <el-table-column
                  prop="bet" align="center" width=100 sortable="custom"
                  :label="$t('nav.배팅')">
                   <template slot-scope="scope"> <span class="text-info">{{ formatMoney(scope.row.bet)}}</span></template>
                </el-table-column>
                <el-table-column
                  prop="win" align="center" width=100 sortable="custom"
                  :label="$t('msg.당첨')">
                    <template slot-scope="scope"> <span class="text-success">{{ formatMoney(scope.row.win)}}</span></template>
                </el-table-column>
                <el-table-column
                  prop="balance" align="center" width=100
                  :label="$t('msg.잔고')">
                    <template slot-scope="scope"> <span >{{ formatMoney(scope.row.balance)}}</span></template>
                </el-table-column>
                <el-table-column
                  prop="create_at" align="center" sortable="custom"
                  :label="$t('msg.일시')">
                </el-table-column>
                <el-table-column
                  prop="txid" align="center" width=80
                  :label="$t('msg.상세')">
                   <template slot-scope="scope">
        
                          <el-button type="primary" size="mini" @click="linkBtn(scope)" style="padding:2px;" plain>{{$t('msg.상세보기')}}</el-button>
 
                  </template>
                </el-table-column> 
              </el-table>
             
</div>
 </template>

 <script>
   import transaction from './transaction.vue';
   import bettingDetails from './betting-details.vue';
   import holdem from './holdem.vue';
    export default {
     components: {
    
     transaction,bettingDetails,holdem
    },
       props:{
      //接收父组件传来的id值
      info:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      //  bets:{
      //   type:Array,
      //   default:()=>{
      //     return {}
      //   }
      // },
     
      // gameProvider:{
      //   type:String,
      //   default:""
      // },
    
      //  banker_cards:{
      //   type:Array,
      //   default:()=>[]
        
      // },
       layerid:{
        type:String,
        default:""
      },
      
    },
    	data(){
    		return{
                loading:false,
                tabList:[],
                prop:'',
                order:'',
                currentPage:1,
                total:0,
                size:0,
                domain:window.sessionStorage.getItem('domain'),
    			
    			
    		}
        },
    created() {
        
        this.jackpotList()
         
         
    },
    	
    	methods:{
          tableRowClassName({row, rowIndex}) {
                
                   if (rowIndex%2 === 1) {
                    return 'odd-row';
                   }
                   else{
                     return 'edd-row';
                   }
                },
          tableSortChange(column) {
 
                 this.prop= column.prop
                 this.order= column.order
                 
                this.jackpotList()
             },
           
            jackpotList(){
     
              this.loading = true
              let token=window.sessionStorage.getItem('user');
                      this.$axios({
                          method:'get',
                          url:this.domain+'/admin/max_win?page='+this.currentPage+'&fit='+this.prop+'&order='+this.order,
                          'Accept': 'application/json',
                           headers: { 'Authorization': 'Bearer ' + token },
                        
                    }).then((response) =>{ 


                      if(response.data.code!=200)
                      {
                          this.$message({
                                  message:response.data.msg,
                                  type:'error'
                              })  

                             this.loading = false
                           

                          return;
                      }

                            
                             let item = response.data   
                             this.tabList =item.data
 //console.log('tabdata=',this.tabList)
                             this.loading = false
                           
                           
                       
                    }).catch((error) =>{
                         this.loading = false
                           
                       
                    })
        },
          // handleSizeChange(val) {
          //     //console.log(`每页 ${val} 条`);
          //      this.size = val
          //     this.jackpotList();
          //     this.loading= true

          //   },
          //   handleCurrentChange(val) {
          //     //console.log(`当前页: ${val}`);
          //     this.currentPage = val
          //     this.jackpotList();
          //     this.loading= true
          //   },
            linkBtn(e){

           let token=window.sessionStorage.getItem('user');
           this.$axios({
                  method:'get',
                  url:this.domain+'/admin/getGameCategory?provider_name='+e.row.provider_name+'&opcode='+e.row.opcode+'&admin_id='+e.row.admin_id+'&dd='+e.row.create_at+'&user_id='+e.row.user_id+'&username='+e.row.username+'&ping='+e.row.ping+'&round_id='+e.row.round_id+'&txid='+e.row.txid,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
 
            }).then((response) =>{ 

             if ( response.data.code == "500")
             {
                 alert(response.data.msg);
             }
             else if(response.data.code=="100"){
              
                   let bets=response.data.data.data.data.participants[0].bets;
              let newbet1=[];
              let newbet2=[];
              let newbet3=[];
              let newbet4=[];

              let modifiedArr = bets.map(function(element){
                 if(element["code"].indexOf("Banker")>0)
                 { 
                      newbet1.push(element);
                 }
                 if(element["code"].indexOf("Player")>0)
                 { 
                      newbet2.push(element);
                 }
                 if(element["code"].indexOf("Tie")>0)
                 { 
                      newbet3.push(element);
                 }
                 if(element["code"].indexOf("Etc")>0)
                 { 
                      newbet4.push(element);
                 }
                 
                 
              });
              console.log('newbet1',newbet1)

                 
                  this.$layer.iframe({
                    type: 2,
                    title: e.row.username+' '+e.row.create_at,
                    content: {
                        content: transaction,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        BAC_Banker:newbet1,
                        BAC_Player:newbet2,
                        BAC_Tie:newbet3,
                        BAC_Etc:newbet4,
                        outcome:response.data.data.data.data.result.outcome,
                        banker_cards:response.data.data.data.data.result.banker.cards,
                        player_cards:response.data.data.data.data.result.player.cards,
                        banker:{score:response.data.data.data.data.result.banker.score},
                        player:{score:response.data.data.data.data.result.player.score},
                        dealer:{name:response.data.data.data.data.dealer.name},
                        table:{name:response.data.data.data.data.table.name},
                        gameProvider:response.data.data.data.data.gameProvider,
                        totalStake:response.data.data.data.data.totalStake,
                        totalPayout:response.data.data.data.data.totalPayout,
                        gameType:response.data.data.data.data.gameType,
                        status:response.data.data.data.data.status,
                        settledAt:response.data.data.data.data.settledAt,
                        skin: 'layer_bg',
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['830px', '850px'],
                 
                });

             }
             else if(response.data.code=="300"){
              console.log(response.data.mem_id)
               this.$layer.iframe({
                    type: 2,
                    title: '베팅 상세 내역',
                    content: {
                        content: bettingDetails,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        status:response.data.data.data.status,
                        settledAt:response.data.data.data.settledAt,
                        startedAt:response.data.data.data.startedAt,
                        table:{name:response.data.data.data.table.name},
                        dealer:{name:response.data.data.data.dealer.name},
                        gameProvider:response.data.data.data.gameProvider,
                        banker_cards:response.data.data.data.result.banker.cards,
                        player_cards:response.data.data.data.result.player.cards,
                        outcome:response.data.data.data.result.outcome,
                        banker:{score:response.data.data.data.result.banker.score},
                        player:{score:response.data.data.data.result.player.score},
                        bets:response.data.data.data.participants[0].bets,
                        agent:response.data.agent,
                        mem_id:response.data.mem_id,
                        orders:response.data.orders,
                       
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['1000px', '850px'],
                 
                });

             }else if(response.data.code=="301"){


               if(typeof(response.data.data.detail.data.result.banker) == "undefined")
               {
                   this.$layer.iframe({
                    type: 2,
                    title: '베팅 상세 내역',
                    content: {
                        content: holdem,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        status:response.data.data.detail.data.status,
                        settledAt:response.data.data.detail.data.settledAt,
                        startedAt:response.data.data.detail.data.startedAt,
                        table:{name:response.data.data.detail.data.table.name},
                        dealer:{name:response.data.data.detail.data.dealer.name},
                        gameProvider:response.data.data.detail.data.gameProvider,
                       
                        
                        
                        bets:response.data.data.detail.data.participants[0].bets,
                        agent:response.data.agent,
                        mem_id:response.data.mem_id,
                        orders:response.data.orders,
                       
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['1000px', '850px'],
                 
                  });
                   return;
               }

               this.$layer.iframe({
                    type: 2,
                    title: '베팅 상세 내역',
                    content: {
                        content: bettingDetails,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        status:response.data.data.detail.data.status,
                        settledAt:response.data.data.detail.data.settledAt,
                        startedAt:response.data.data.detail.data.startedAt,
                        table:{name:response.data.data.detail.data.table.name},
                        dealer:{name:response.data.data.detail.data.dealer.name},
                        gameProvider:response.data.data.detail.data.gameProvider,
                        banker_cards:response.data.data.detail.data.result.banker.cards,
                        player_cards:response.data.data.detail.data.result.player.cards,
                        outcome:response.data.data.detail.data.result.outcome,
                        banker:{score:response.data.data.detail.data.result.banker.score},
                        player:{score:response.data.data.detail.data.result.player.score},
                        bets:response.data.data.detail.data.participants[0].bets,
                        agent:response.data.agent,
                        mem_id:response.data.mem_id,
                        orders:response.data.orders,
                       
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['1000px', '850px'],
                 
                });

             }else if(response.data.code=="302"){
               this.$layer.iframe({
                    type: 2,
                    title: '베팅 상세 내역',
                    content: {
                        content: bettingDetails,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        status:response.data.data.status,
                        settledAt:response.data.data.startedAt,
                        startedAt:response.data.data.startedAt,
                        table:{name:''},
                        dealer:{name:response.data.data.dealer.name},
                        gameProvider:response.data.data.vendor,
                        banker_cards:response.data.data.result.banker.cards,
                        player_cards:response.data.data.result.player.cards,
                        outcome:response.data.data.result.outcome,
                        banker:{score:response.data.data.result.banker.score},
                        player:{score:response.data.data.result.player.score},
                        bets:response.data.data.details.bets,
                        agent:response.data.agent,
                        mem_id:response.data.mem_id,
                        orders:response.data.orders,
                       
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['1000px', '850px'],
                 
                });

             }else if(response.data.code=="303"){
            
               this.$layer.iframe({
                    type: 2,
                    title: '베팅 상세 내역',
                    content: {
                        content: holdem,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        status:response.data.data.status,
                        settledAt:response.data.data.startedAt,
                        startedAt:response.data.data.startedAt,
                        table:{name:''},
                        dealer:{name:response.data.data.dealer.name},
                        gameProvider:response.data.data.vendor,
                       
                        
                        
                        bets:response.data.data.details.bets,
                        agent:response.data.agent,
                        mem_id:response.data.mem_id,
                        orders:response.data.orders,
                       
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['1000px', '850px'],
                 
                });

             }else if(response.data.code=="400"){
              console.log(response.data.data.data)
               this.$layer.iframe({
                    type: 2,
                    title: '베팅 상세 내역',
                    content: {
                        content: holdem,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        status:response.data.data.data.status,
                        settledAt:response.data.data.data.settledAt,
                        startedAt:response.data.data.data.startedAt,
                        table:{name:response.data.data.data.table.name},
                        dealer:{name:response.data.data.data.dealer.name},
                        gameProvider:response.data.data.data.gameProvider,
                       
                        
                        
                        bets:response.data.data.data.participants[0].bets,
                        agent:response.data.agent,
                        mem_id:response.data.mem_id,
                        orders:response.data.orders,
                       
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['1000px', '850px'],
                 
                });

             }else
             {
                 window.open(response.data.data,'_blank')
             }
                 
                 
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })

          console.log(e);

          //window.open(this.urlLink,'_blank')
        },
                	
 
    	
    	
    	
    		
    	}
  }
</script>

 <style scoped>


</style>


// WEBPACK FOOTER //
// src/components/common/jackpot.vue